import { createAction } from 'Helpers';
import fileTypes from './types';

const fileActions = {
	uploadRequest: createAction(fileTypes.UPLOAD.REQUEST),
	uploadSuccess: createAction(fileTypes.UPLOAD.SUCCESS),
	uploadFailure: createAction(fileTypes.UPLOAD.FAILURE),
	uploadClear: createAction(fileTypes.UPLOAD.CLEAR),

	deleteRequest: createAction(fileTypes.DELETE.REQUEST),
	deleteSuccess: createAction(fileTypes.DELETE.SUCCESS),
	deleteFailure: createAction(fileTypes.DELETE.FAILURE),
	deleteClear: createAction(fileTypes.DELETE.CLEAR),

	readFileFromPathRequest: createAction(fileTypes.READ_FROM_PATH.REQUEST),
	readFileFromPathSuccess: createAction(fileTypes.READ_FROM_PATH.SUCCESS),
	readFileFromPathFailure: createAction(fileTypes.READ_FROM_PATH.FAILURE),
	readFileFromPathClear: createAction(fileTypes.READ_FROM_PATH.CLEAR),
};

export default fileActions;
